import React from "react";

// Dynasty Metrics mark — ascending data bars (no football imagery).
export function BrandMark({ size = 32, className = "" }) {
  return (
    <div
      className={`rounded-sm bg-[var(--accent)] flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      data-testid="brand-mark"
    >
      <svg viewBox="0 0 24 24" width={size * 0.62} height={size * 0.62} fill="none">
        <rect x="3" y="14" width="4" height="7" fill="#000" />
        <rect x="10" y="9" width="4" height="12" fill="#000" />
        <rect x="17" y="3" width="4" height="18" fill="#000" />
      </svg>
    </div>
  );
}

export function Wordmark({ size = 32, sub = "DYNASTY ANALYTICS", title = "Dynasty Metrics", className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <BrandMark size={size} />
      <div>
        <div className="font-display font-black leading-none tracking-tight">{title}</div>
        {sub && <div className="text-[10px] tracking-[0.25em] text-[var(--text-3)] mt-0.5">{sub}</div>}
      </div>
    </div>
  );
}
